"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrettyLoader = void 0;
const config_default_1 = require("./config-default");
const PrettyLoaderType_1 = require("./PrettyLoaderType");
class PrettyLoader {
    constructor(element, config = {}) {
        this.element = element;
        this.config = Object.assign(Object.assign(Object.assign({}, config_default_1.configDefault), config), this.loadConfigFromDataset());
        this.element.dataset.loaderInit = '1';
        if (!this.element.classList.contains('pretty-loadder')) {
            this.element.classList.add('pretty-loader');
        }
        if (!this.element.querySelector('.pretty-loader__label')) {
            const prettyLoaderLabel = document.createElement('span');
            prettyLoaderLabel.className = 'pretty-loader__label';
            const range = document.createRange();
            range.selectNodeContents(this.element);
            range.surroundContents(prettyLoaderLabel);
            this.element.appendChild(prettyLoaderLabel);
        }
        if (!this.element.querySelector('.pretty-loader__content')) {
            const prettyLoaderContent = document.createElement('span');
            prettyLoaderContent.classList.add('pretty-loader__content');
            if (this.config.type === PrettyLoaderType_1.PrettyLoaderType.dots) {
                prettyLoaderContent.classList.add('pretty-loader__content_dots');
                prettyLoaderContent.innerHTML = this.renderDots();
            }
            else if (this.config.type === PrettyLoaderType_1.PrettyLoaderType.circleDots) {
                prettyLoaderContent.innerHTML = this.renderCircleDots();
            }
            else {
                prettyLoaderContent.innerHTML = this.renderCircle();
            }
            this.element.appendChild(prettyLoaderContent);
        }
    }
    static init(element, config) {
        return new this(element, config);
    }
    show() {
        this.element.classList.add('pretty-loader_active');
        this.element.setAttribute('disabled', '');
    }
    hide() {
        delete this.element.dataset.loaderInit;
        this.element.classList.remove('pretty-loader_active');
        this.element.removeAttribute('disabled');
    }
    renderDots() {
        return `
      ${this.renderDot(1)}
      ${this.renderDot(2)}
      ${this.renderDot(3)}
    `;
    }
    renderDot(iteration = 1) {
        const begin = iteration / 10;
        const radius = this.config.size / 2;
        return `
      <svg xmlns="http://www.w3.org/2000/svg" width="${this.config.size}" height="${this.config.size}">
        <circle fill="${this.config.color}" stroke="none" cx="${radius}" cy="${radius}" r="${radius}">
            <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="${begin}"></animate>
        </circle>
      </svg>
    `;
    }
    renderCircle() {
        return `
      <svg class="loader-circle" viewBox="25 25 50 50"
        width="${this.config.circleSize}"
        height="${this.config.circleSize}"
        stroke-width="5">
        <circle cx="50" cy="50" r="20" stroke="${this.config.color}"></circle>
    </svg>
    `;
    }
    renderCircleDots() {
        const circles = [
            { cx: '13.6726', cy: '3.67423' },
            { cx: '24.3875', cy: '11.018' },
            { cx: '19.5418', cy: '22.7758' },
            { cx: '7.67458', cy: '22.7211' },
            { cx: '3.67458', cy: '11.018' },
        ];
        return `
    <svg class="loader-circleDots" 
        width="${this.config.size}"
        height="${this.config.size}" viewBox="0 0 29 27">
        ${circles.map(({ cx, cy }) => `<circle cx="${cx}" cy="${cy}" r="3" fill="${this.config.color}"/>`).join('')}
    </svg>
    `;
    }
    loadConfigFromDataset() {
        const config = {};
        if ('configType' in this.element.dataset) {
            config.type = this.element.dataset.configType;
        }
        if ('configColor' in this.element.dataset) {
            config.color = this.element.dataset.configColor;
        }
        if ('configSize' in this.element.dataset) {
            config.size = Number(this.element.dataset.configSize);
        }
        if ('configCircleSize' in this.element.dataset) {
            config.circleSize = Number(this.element.dataset.configCircleSize);
        }
        return config;
    }
}
exports.PrettyLoader = PrettyLoader;
